import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import FireRescueDetails from '../../subdepartmentdetails/FireRescue'


function FireRescue() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Fire and Rescue Services || Public Safety";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Public Safety"
            title="Fire Rescue"
            subtitledown="Department of Public Safety"
           />
            <FireRescueDetails/>
        </div>
    </>
  )
}

export default FireRescue